<div class="wrapper">
  <a class="logo" routerLink="domu">
    <img alt="logo" src="assets/img/logo.svg" />
  </a>
  @if (deviceSvc.isMobile) {

    <div class="button-group">
      <img (pointerup)="deviceSvc.hamburgerMenu = true"
           alt="menu"
           src="assets/img/menu-icon.svg" />
      <app-lang-picker></app-lang-picker>
    </div>

  } @else {
    <div class="menu-items">
      @for (item of menuItems; track item) {
        <app-menu-item-desktop
          [item]="item">
        </app-menu-item-desktop>
      }
      <app-lang-picker></app-lang-picker>
    </div>
  }
</div>
